import { Button, CardLayout, CardLayoutProps } from '@pletly/ui';

export const NewConnectionContainer = ({
	title,
	subtitle,
	onSubmit,
	isSubmitDisabled,
	submitLabel,
	children,
}: Props) => {
	return (
		<CardLayout title={title} subtitle={subtitle}>
			{children}
			<Button variant="filled" color="primary" onPress={onSubmit} disabled={isSubmitDisabled}>
				{submitLabel}
			</Button>
		</CardLayout>
	);
};

type Props = CardLayoutProps & {
	submitLabel: string;
	onSubmit: () => void;
	isSubmitDisabled?: boolean;
};
